module.exports = __webpack_public_path__ + "media/images/logo-82267c9840d65aa504fe0a16d3505333.svg";